/**
 * Cart Count Component
 *
 * Displays the cart item count, excluding the full box line item
 */
customElements.define('code-cart-count', class extends HTMLElement {
  async connectedCallback() {
    // Subscribe to cart updates
    this.unsubscribe = subscribe('cartUpdate', ({ item_count, items }) => {
      // Calculate the actual item count, excluding the full box variant
      const actualCount = this.calculateActualCount(items, item_count);

      // Update the display
      if (actualCount !== undefined) {
        this.innerText = `${actualCount}`;
        this.toggleAttribute('data-active', actualCount > 0);
        this.toggleAttribute('data-visible', actualCount > 0);

        // Add animation when count increases
        if (actualCount > 0) {
          setTimeout(() => {
            this.toggleAttribute('data-active', false);
          }, 300);
        }
      }
    });
  }

  disconnectedCallback() {
    // Clean up subscription when component is removed
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  /**
   * Calculate actual cart count excluding full box line item
   * @param {Array} items - Cart items array
   * @param {number} item_count - Total item count from cart
   * @returns {number} - Actual item count
   */
  calculateActualCount(items, item_count) {
    // If we don't have items array, return the item_count as is
    if (!items || !Array.isArray(items)) {
      return item_count;
    }

    // Get the full box variant ID from window
    const fullBoxVariantId = window.fullBoxProduct;

    // If no full box variant ID is configured, return the item_count as is
    if (!fullBoxVariantId) {
      return item_count;
    }

    // Find the full box item in the cart
    const fullBoxItem = items.find(item => item.variant_id === fullBoxVariantId);

    // If full box item exists, subtract its quantity from the total
    if (fullBoxItem) {
      return item_count - fullBoxItem.quantity;
    }

    // Otherwise return the item count as is
    return item_count;
  }
});
